import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { AlertCircle, ArrowLeft, ArrowRight, Mail } from 'lucide-react';

const BillingCancel = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-bissa-light">
      <Card className="w-full max-w-md">
        <CardContent className="pt-12 pb-12">
          <div className="text-center space-y-6">
            {/* Cancel Icon */}
            <div className="w-16 h-16 bg-yellow-50 rounded-full flex items-center justify-center mx-auto">
              <AlertCircle className="w-8 h-8 text-yellow-600" />
            </div>

            {/* Title and Message */}
            <div>
              <h2 className="text-2xl font-bold text-bissa-blue mb-2">
                Payment Cancelled
              </h2>
              <p className="text-gray-600">
                No worries! Your payment was cancelled and no charges were made to your account.
              </p>
            </div>

            {/* Information */}
            <div className="bg-blue-50 p-4 rounded-lg space-y-2 text-sm text-left">
              <h3 className="font-semibold text-bissa-blue mb-2">What happened?</h3>
              <ul className="space-y-2">
                <li className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 bg-bissa-blue rounded-full flex-shrink-0 mt-2"></span>
                  <span>You cancelled the payment process</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 bg-bissa-blue rounded-full flex-shrink-0 mt-2"></span>
                  <span>No charges were made to your payment method</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 bg-bissa-blue rounded-full flex-shrink-0 mt-2"></span>
                  <span>Your current plan remains unchanged</span>
                </li>
              </ul>
            </div>

            {/* Reasons & Help */}
            <div className="text-left">
              <h3 className="font-semibold text-bissa-blue mb-3 text-center">Need Help?</h3>
              <div className="space-y-3 text-sm">
                <div className="flex items-start gap-3">
                  <Mail className="w-4 h-4 text-bissa-blue flex-shrink-0 mt-0.5" />
                  <div>
                    <span className="font-medium">Questions about pricing?</span>
                    <br />
                    <span className="text-gray-600">Contact our team for personalized help</span>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <AlertCircle className="w-4 h-4 text-bissa-blue flex-shrink-0 mt-0.5" />
                  <div>
                    <span className="font-medium">Payment issues?</span>
                    <br />
                    <span className="text-gray-600">We support all major credit cards and PayPal</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="space-y-3">
              <Button asChild className="w-full bg-bissa-blue text-white hover:bg-bissa-gold hover:text-bissa-blue">
                <Link to="/billing">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Try Again
                </Link>
              </Button>
              
              <div className="flex gap-3">
                <Button variant="outline" asChild className="flex-1">
                  <Link to="/dashboard">
                    Dashboard
                  </Link>
                </Button>
                <Button variant="outline" asChild className="flex-1">
                  <Link to="/settings">
                    Get Help
                  </Link>
                </Button>
              </div>
            </div>

            {/* Alternative Options */}
            <div className="pt-4 border-t">
              <h4 className="font-semibold text-bissa-blue mb-3">Still interested in upgrading?</h4>
              <p className="text-sm text-gray-600 mb-4">
                Explore our features and see how Bissa.ai can help grow your business.
              </p>
              <Button variant="outline" asChild className="w-full">
                <Link to="/">
                  Learn More About Our Plans
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Link>
              </Button>
            </div>

            {/* Contact Support */}
            <div className="text-xs text-gray-500">
              Questions? Contact us at{' '}
              <a href="mailto:support@bissa.ai" className="text-bissa-blue hover:underline">
                support@bissa.ai
              </a>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BillingCancel;